import { BaseControlValueAccessor } from './base.accessor';

export abstract class ValueAccessor<T> extends BaseControlValueAccessor<T> {
  disabled = false;

  set value(value: T) {
    this._value = value;
    this.onChange(value);
  }

  get value() {
    return this._value;
  }

  private _value!: T;

  writeValue(value: T): void {
    this._value = value;
    if (!!value) {
      this.onChange(value);
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelTouched = () => {};

  override registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
}
